<template>
  <div class="wrapper">
    <div class="top-nav">
      <div>
        <nav-common :nav="nav"></nav-common>
      </div>
    </div>
    <div class="detail">
      <item-detail :detail="detail"></item-detail>
    </div>
  </div>
</template>
<style scoped>
.top-nav {
  width: 100%;
  display: flex;
}
.detail {
  margin-top: 30px;
  width: 100%;
  border-width: 20px 1px 1px 1px;
  border-style: solid;
  border-color:#E6ECF2;
  padding:40px 30px;
  box-sizing: border-box;
  border-radius: 10px;
}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import itemDetail from "@/components/views/common/itemDetail.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      nav: {
        firsttitle: "",
        firstrouteName: "",
        secondtitle: "",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      },
      detail:{}
    };
  },
  methods: {
        getDetail() {
      userApi.getpartyDeatil({id:this.$route.query.id}).then(res => {
        this.detail = res.data;
      });
    }
  },
  components: {
    navCommon,
    itemDetail
  },
  mounted() {
    if (this.$route.query.section == "2") {
      this.nav.firsttitle = "党建动态";
    } else if (this.$route.query.section == "3") {
      this.nav.firsttitle = "党风廉政";
    } else if (this.$route.query.section == "4") {
      this.nav.firsttitle = "群团建设";
    } else if (this.$route.query.section == "5") {
      this.nav.firsttitle = "图片新闻";
    } else {
      this.nav.firsttitle = "专题活动";
    }
  this.getDetail()
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/ComParty/detail.vue